<template lang="pug">
.view-user
  ui-navbar-panel.mb-20(backLink="cronTasks", backLinkText="К списку")
    template(slot="filters")
      span Новая CRON-задача

    template
      b-button.is-primary(@click="save", icon-left="check") Сохранить

  .container(v-if="!task.$state.loading")
    form-component(
      v-model="task",
      form="new-cron-task-form",
      ref="form",
      @afterCreate="routeToCronTask"
    )
</template>

<script>
import BButton from 'buefy/src/components/button/Button';
import BField from 'buefy/src/components/field/Field';
import BIcon from 'buefy/src/components/icon/Icon';
import ServerJob from '@/models/ServerJob';

export default {
  name: 'view-new-cron-task',
  components: { BIcon, BField, BButton },

  data: () => ({
    task: new ServerJob(),
  }),

  methods: {
    save() {
      this.$refs.form.save();
    },

    routeToCronTask({ id }) {
      this.$router.replace({ name: 'editCronTask', params: { id } });
    },
  },

  created() {
    this.task.status = 'wait';
  },
};
</script>
